import React, { useState } from 'react';
import userIcon from '../../assets/images/user.png';
import Text from '../single_component/Text';
import Image from '../single_component/Image';
import Box from '../single_component/Box';
import Circle from '@mui/icons-material/Circle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Priority from './Priority';
import DeleteConfirmModal from './DeleteConfirmModal';
import Props from '../../types/props';
import StringUtils from '../../utils/stringUtil';
import { ROLE } from '../../types/routeObject';
import moment from 'moment';
import { toast } from 'react-toastify';

function ToDosList({ ...props }: Props) {
  const { value, deleteTodo } = props.extra;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    const response = await deleteTodo(value.todoId);
    setDeleteLoading(false);
    setDeleteModalOpen(false);
    if (response.success) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
  };

  console.error(value);
  return (
    <Box
      style={{
        gap: 2,
        borderBottom: '1px solid #EDEDED ',
        padding: '12px 14px',
      }}>
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box style={{ display: 'flex', gap: 2 }}>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
              }}>
              <Circle sx={{ fontSize: 8, color: '#104960' }} />
              <Text style={{ fontSize: 14, fontWeight: 'bolder' }}>
                {StringUtils.capitalizeFirstLetter(value.subject)}
              </Text>
            </Box>
            <Text style={{ color: '#757575', fontWeight: 500, fontSize: 13 }}>
              {moment(value.startDate, 'YYYY-MM-DD').format('MMM DD, YYYY')} -{' '}
              {moment(value.endDate, 'YYYY-MM-DD').format('MMM DD, YYYY')}
            </Text>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Priority label={value.priority} />
            <DeleteOutlineIcon
              sx={{ cursor: 'pointer', color: '#d32f2f', fontSize: 18 }}
              onClick={() => setDeleteModalOpen(true)}
            />
          </Box>
        </Box>

        <Box style={{ marginTop: 0.7 }}>
          <Text style={{ fontSize: 13, color: '#104960' }}>
            {StringUtils.capitalizeFirstLetter(value.note)}
          </Text>
        </Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginTop: 0.7,
            color: '#104960',
          }}>
          <Image src={userIcon} />
          <Text style={{ color: '#104960', fontSize: 14 }}>
            {StringUtils.capitalizeFirstLetter(value?.assignedTo?.name)}
          </Text>

          <Box style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Circle sx={{ fontSize: 8 }} />
            <Text style={{ fontSize: 14 }}>
              {value?.assignedTo?.roleId == ROLE.ADMIN
                ? 'Admin'
                : 'Sales-Executive'}
            </Text>
          </Box>
        </Box>
      </Box>
      <DeleteConfirmModal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
        loading={deleteLoading}
      />
    </Box>
  );
}

export default ToDosList;
